export default __webpack_public_path__ + "static/brcc-full-width-3-mobile-562eb3221511a5d21c53f8af3cbe382c.webp";